<template>
  <div class="carousel_wrap">
    <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <div>{{ item.en }}</div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <div>{{ item.en }}</div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          src: require('@/assets/img/banner1.jpg'),
          line1: '位列制造强国战略的“五大工程”之首',
          en:'Ranks first among the "Five Major Projects" of the manufacturing power strategy'
        },
        {
          src: require('@/assets/img/banner2.jpg'),
          line1: '加快建设全球先进制造业基地 ， 打响 “浙江制造 ” 品牌 ， 助力制造强国建设',
          en:'Accelerate the construction of a world-class advanced manufacturing base, build the reputation of the "Zhejiang Manufacturing" brand, and contribute to the development of a manufacturing power'
        },
        {
          src: require('@/assets/img/banner2.jpg'),
          line1: '主动对接国家制造业创新中心布局战略',
          en:'Proactively align with the national layout strategy for manufacturing innovation centers'
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    width: 70%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    color: #fff;
    font-size: 25px;

    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
</style>